module.exports = __webpack_public_path__ + "img/benjamin-voros-unsplash-mountain-stars__.b5be6dd2.jpeg";